module.exports = "<div class=\"month-selector\">\n  <div class=\"previous-month\"\n       ng-click=\"$ctrl.prev()\">\n    <span class=\"icon-arrow-select-up\"></span>\n  </div>\n  <div class=\"month-literals\">\n    {{$ctrl.monthLiteral}} {{$ctrl.yearLiteral}}\n  </div>\n  <div class=\"next-month\"\n       ng-click=\"$ctrl.next()\">\n    <span class=\"icon-arrow-select-up\"></span>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/vacations-absences.module/features/teamCalendarMobile/monthSelector/monthSelector.html
// module id = 1307
// module chunks = 0